import { CustomVizDefinition } from 'libs/end-to-end/src/custom-viz-definition';
import { BiasAnalysisOutput } from 'libs/end-to-end/src/bias-analysis';

export const BiasAnalysisCustomVizDefinition: CustomVizDefinition = {
  customVizId: 'biasAnalysis',
  isDataQueuingAllowed: true,
  outputFileName: 'bias_analysis_output.json',
  outputSchema: BiasAnalysisOutput,
  resolveFocusArea: (request) => {
    if (request.customVizId !== 'biasAnalysis') {
      throw new Error('Invalid customVizId');
    }
    return request.inputs.extras.focusArea;
  },
  resolveFilters: (request) => {
    if (request.customVizId !== 'biasAnalysis') {
      throw new Error('Invalid customVizId');
    }
    return request.inputs.extras.filters;
  },
  resolveAnalysisName: () => undefined,
  checkEnoughDataStateEnabledGate: true,
  complexityParams: {
    aValue: 0.241,
    multiplier: 0.846,
  },
  eventProperties: (request) => {
    if (request.customVizId !== 'biasAnalysis') {
      throw new Error('Invalid customVizId');
    }
    return {
      'Custom Viz Type': request.customVizId,
      Filters: request.inputs.extras.filters,
      'Selected Dimensions': [request.inputs.extras.dimension],
      'Selected Metrics': [request.inputs.extras.metric],
      'Selected Focus Areas': [request.inputs.extras.focusArea],
    };
  },
  getUrlPath: (focusArea, request) => {
    if (request.customVizId !== 'biasAnalysis') {
      throw new Error('Invalid customVizId');
    }

    if (!focusArea) {
      return null;
    }

    return `${focusArea}/summary-v2`;
  },
};
